import React, { useEffect, useState } from 'react'
import { AppContent } from '../components/index'
import SideMenuBar from 'src/components/SideMenuBar/SideMenuBar.jsx'
import { useLocation } from 'react-router-dom'
import './DefaultLayout.scss'
import { getToken } from '../apiHelper/helper'
import { sidePanelFreeRoutes } from '../routes'

const DefaultLayout = () => {
  const authToken = getToken()
  const location = useLocation()

  const [isHaveSideMenu, setIsHaveSideMenu] = useState(false)

  useEffect(() => {
    if (
      !location.pathname.includes('/resetPassword') &&
      !location.pathname.includes('/OTPVerify') &&
      !location.pathname.includes('/MFALogin') &&
      !authToken
    ) {
      window.location.href = '#/login'
    }
  }, [authToken])

  useEffect(() => {
    setIsHaveSideMenu(!sidePanelFreeRoutes.includes(location.pathname))
  }, [location.pathname])

  const isEncounterDetails = location.pathname === '/newEncounter'

  return (
    <>
      {isHaveSideMenu ? <SideMenuBar /> : null}

      <div
        className={`app-body${isHaveSideMenu ? ' wrapper d-flex flex-column min-vh-100' : ''}`}
        style={{ ...(isEncounterDetails && { width: '99%' }) }}
      >
        <AppContent />
      </div>
    </>
  )
}

export default DefaultLayout
